module.exports = __webpack_public_path__ + "static/media/pilot_veille.3c20ee79.png";